// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + ".mp." + {"FavouritesUiDynamicBuyerInfoModal":"4a81ee6d","SmartBannerFullScreen":"20841819"}[chunkId] + ".css";
};